module.exports = __webpack_public_path__ + "static/media/mgo_3_2_ws.0744f331.pdf";